<template>
  <div class="vx-col w-full lg:w-1/2">
    <div class="vx-col w-full mt-base">
       <vx-card title="Profil" class="mt-base">
        <div class="mt-5">
          <h6>Nama :</h6>
          <p>{{ pengguna.nama }}</p>
        </div>

        <div class="mt-5">
          <h6>NIP :</h6>
          <p>{{ pengguna.nip }}</p>
        </div>

        <div class="mt-5">
          <h6>Jabatan :</h6>
          <p>{{ pengguna.jabatan.nama }}</p>
        </div>

        <div class="mt-5">
          <h6>Bidang :</h6>
          <p>{{ pengguna.jabatan.bidang.nama }}</p>
        </div>

        <div class="mt-5">
          <h6>Alamat :</h6>
          <p>{{ pengguna.alamat }}</p>
        </div>

        <div class="mt-5">
          <h6>Telepon :</h6>
          <p>{{ pengguna.telepon }}</p>
        </div>

        <div class="mt-5">
          <h6>Tanggal Lahir :</h6>
          <p>{{ pengguna.tgl_lahir }}</p>
        </div>

        <vs-button
          type="gradient"
          class="w-full mt-6"
          color="#7367F0"
          gradient-color-secondary="#CE9FFC"
          @click="$refs.dialogUpdateProfile.toggleActive(true)"
          >Update Profil
        </vs-button>
       </vx-card>
    </div>
    <DialogUpdateProfile
      ref="dialogUpdateProfile"
      :pengguna="pengguna"
      @refreshPengguna="submitCallback"
    />
  </div>
</template>

<script>
import DialogUpdateProfile from "./DialogUpdateProfile";

export default {
  components: {
    DialogUpdateProfile
  },
  props: {
    pengguna: {
      type: Object
    }
  },
  methods: {
    submitCallback() {
      this.$emit('refreshPengguna');
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>